import { animationTransition } from '@shared/joykit/packages/core/utils';
import { styled, Menu } from '@withjoy/joykit';

export const WrapperMenu = styled(Menu)`
  width: 256px;
  padding: ${props => props.theme.space[6]} ${props => props.theme.space[5]};
  gap: ${props => props.theme.space[5]};
  background-color: white;
  position: absolute;
  border-radius: 12px;
  margin-top: ${props => props.theme.space[3]};
  box-shadow:
    0px 4px 16px 0px rgba(0, 0, 0, 0.07),
    0px 7px 27px 0px rgba(44, 41, 37, 0.06);
  z-index: ${props => props.theme.zIndices.popover};
`;

export const StyledItemWrapper = styled(Menu.Item)`
  border-radius: 16px;
  padding: 0px;
  padding-left: ${props => props.theme.space[5]};
  padding-right: ${props => props.theme.space[5]};
  width: 100%;
  position: relative;

  /* Use pseudo-element for full-width hover background */
  /* The hover background extends to the edges by using absolute positioning */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 16px;
    background: transparent;
    z-index: -1;
    transition: background-color 0.2s ease;
  }

  &:hover::before {
    background: ${props => props.theme.colors.mono2};
  }

  &:active::before {
    background: ${props => props.theme.colors.fillLightHover};
  }

  &:active {
    & > svg {
      fill: ${props => props.theme.colors.linkActive};
    }
  }

  &:focus {
    border: 2px solid ${props => props.theme.colors.stroke};
  }
`;

export const BurgerIconWrapper = styled.button<{ isActive: boolean }>`
  background-color: ${({ isActive, theme }) => (isActive ? theme.colors.mono3 : theme.colors.transparent)};
  transition: ${animationTransition('background-color')};
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.mono2};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.mono3};
  }
`;

export const MenuDivider = styled.div`
  margin: 9px ${props => props.theme.space[4]};
  height: 1px;
  background-color: ${props => props.theme.colors.mono3};
`;
